import { render, staticRenderFns } from "./ReportsTable.vue?vue&type=template&id=f997213a&"
import script from "./ReportsTable.vue?vue&type=script&lang=js&"
export * from "./ReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports